
import {useEffect} from "react";
import {useHistory} from "react-router-dom";
import {useRecoilState, DefaultValue} from "recoil";
import accessTokenState from "../state/accessTokenState";

const useStripSearchParameters = () => {
  const history = useHistory();
  const [accessToken, setAccessToken] = useRecoilState(accessTokenState);

  useEffect(() => {
    const params = (new URLSearchParams(window.location.search));

    if (params.get('token') == accessToken) {
      params.delete('token');
      history.replace({
        search: params.toString(),
      })
    }
  }, [accessToken]);
}

export default useStripSearchParameters;
